import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 查看查询结果入口
Mock.mock(/used_car\/get_cbs_report/, 'get' + mockSwitch, {
  'message': 'OK',
  'code': 0,
  'data': {
    'status': 1,
    'detail_info': {
      'Code': 1104,
      'Message': '已出报告',
      'brand': '大众',
      'carComponentRecordsFlag': 0,
      'carConstructRecordsFlag': 0,
      'carFireFlag': 0,
      'carOutsideRecordsFlag': 1,
      'carType': '三厢',
      'carWaterFlag': 0,
      'componentAnalyzeRepairRecords': null,
      'constructAnalyzeRepairRecords': null,
      'displacement': '1.598',
      'effluentStandard': null,
      'lastMainTainTime': '2014-11-16',
      'lastRepairTime': '2016-10-27',
      'mainTainTimes': '0.6',
      'makeDate': '2011',
      'makeReportDate': '2018-12-28 12:05',
      'manufacturer': '上海大众',
      'mileageEstimate': 34529,
      'mileageEveryYear': '6118',
      'mileageIsNormalFlag': 1,
      'modelName': '181CM2',
      'normalRepairRecords': [
        {
          'content': '首次保养; 首次7500公里免费保养; ',
          'date': '2013-05-16',
          'mainTainDate': 1368664680000,
          'materal': '1.6发动机机油4L:1; 朗逸1.6新polo//机油滤清器（D/E互用）:1; ',
          'mileage': 4708,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '首次保养'
        },
        {
          'content': '索赔; 拆装门饰板֐¤; ',
          'date': '2013-05-26',
          'mainTainDate': 1369549080000,
          'materal': '朗逸/右前门把手轴承架:1; ',
          'mileage': 4708,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '索赔'
        },
        {
          'content': '普通索赔; 拆装门饰板; 12项免费项目检测; 10000公里常规保养; ',
          'date': '2013-12-20',
          'mainTainDate': 1387505968000,
          'materal': '朗逸/右前门把手轴承架:1; 朗逸1.6新polo//机油滤清器（D/E互用）:1; 朗逸/空调滤芯:1; 高端机油4L（移库C2):1; ',
          'mileage': 10170,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '普通索赔'
        },
        {
          'content': '事故车维修; 前杠拆装及修复; 前杠喷漆; 后杠拆装; 后杠喷漆; 后杠修复; ',
          'date': '2014-01-25',
          'mainTainDate': 1390608673000,
          'materal': '朗逸/通风栅罩(棉缎黑色):1; 朗逸/前保险杠阻流板-2009.10.01:1; ',
          'mileage': 11887,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '事故车维修'
        },
        {
          'content': '常规保养; 12项免费项目检测; 曾出现打不着火; 右前门偶尔出现锁弹不上来; ',
          'date': '2014-11-16',
          'mainTainDate': 1416103563000,
          'materal': '朗逸1.6新polo//机油滤清器（D/E互用）:1; 高端机油4L（移库C2):1; 发动机润滑系统清洗养护套装:1; 朗逸/双丝斜脚刹车灯泡:1; ',
          'mileage': 17825,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '常规保养'
        },
        {
          'content': '事故车维修; 更换后杠; 后杠喷漆; 后围板钣金; ',
          'date': '2015-01-03',
          'mainTainDate': 1420266375000,
          'materal': '朗逸/右后轮罩衬壳:1; 朗逸/后保险杠(涂底漆):1; 朗逸/右后保险杠固定条:1; 朗逸/后保险杠右边导向槽:1; 朗逸/右后尾灯（深红和白色）2010.08.01-:1; 朗逸/后杠穿心卡子:1; 保险杠螺栓:5; LAVIDA朗逸挡泥板:1; ',
          'mileage': 18360,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '事故车维修'
        },
        {
          'content': '事故车维修; 右前门钣金; 左后门钣金; 左后门喷漆; 右前门喷漆; ',
          'date': '2016-10-27',
          'mainTainDate': 1477557071000,
          'materal': '',
          'mileage': 25828,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '事故车维修'
        }
      ],
      'outsideAnalyzeRepairRecords': [
        {
          'content': '<strong class="light_3">事故车</strong>维修; 前杠拆装及修复; <strong class="light_3">前杠</strong>喷漆; 后杠拆装; <strong class="light_3">后杠</strong>喷漆; <strong class="light_3">后杠</strong>修复; ',
          'date': '2014-01-25',
          'mainTainDate': 1390608673000,
          'materal': '朗逸/通风栅罩(棉缎黑色):1; 朗逸/前保险杠阻流板-2009.10.01:1; ',
          'mileage': 11887,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '事故车维修'
        },
        {
          'content': '<strong class="light_3">事故车</strong>维修; 更换<strong class="light_3">后杠</strong>; <strong class="light_3">后杠</strong>喷漆; 后围板钣金; ',
          'date': '2015-01-03',
          'mainTainDate': 1420266375000,
          'materal': '朗逸/右后轮罩衬壳:1; 朗逸/<strong class="light_3">后保险杠</strong>(涂底漆):1; 朗逸/右后保险杠固定条:1; 朗逸/后保险杠右边导向槽:1; 朗逸/右后尾灯（深红和白色）2010.08.01-:1; 朗逸/<strong class="light_3">后杠</strong>穿心卡子:1; 保险杠螺栓:5; LAVIDA朗逸挡泥板:1; ',
          'mileage': 18360,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '事故车维修'
        },
        {
          'content': '<strong class="light_3">事故车</strong>维修; <strong class="light_3">右前门</strong>钣金; <strong class="light_3">左后门</strong>钣金; <strong class="light_3">左后门</strong>喷漆; <strong class="light_3">右前门</strong>喷漆; ',
          'date': '2016-10-27',
          'mainTainDate': 1477557071000,
          'materal': null,
          'mileage': 25828,
          'payType': null,
          'remark': null,
          'totalMoney': null,
          'type': '事故车维修'
        }
      ],
      'productionArea': '合资',
      'reportNo': '201812281256235556',
      'score': 0,
      'seriesName': '朗逸',
      'transmissionType': '手动档',
      'updateTime': '2018-12-25 15:05',
      'vin': 'LSVAM4187C2184847'
    }
  }
})
